/* eslint-disable camelcase */
import React, { useState } from 'react';
import classNames from 'classnames/bind';
import { beautifyCityString } from '@lib/string';
import { IPrismicImage, IPrismicLink } from '../InteriorDesignersHomePage';

import styles from './ExploreDesigners.module.scss';

export interface IPrismicCategoryGroup {
  image: IPrismicImage;
  link: IPrismicLink;
}
interface IExploreDesignerProps {
  byLocation: IPrismicCategoryGroup;
  byStyle: IPrismicCategoryGroup;
}

const cx = classNames.bind(styles);

const ExploreDesigners = ({
  byLocation,
  byStyle
}: IExploreDesignerProps) => {
  const [isStyleRoom, setCategoryType] = useState(true);

  const byStyleClass = cx({
    Category: true,
    Selected: isStyleRoom
  });
  const byLocationClass = cx({
    Category: true,
    Selected: !isStyleRoom
  });

  const list = isStyleRoom ? byStyle : byLocation as any;

  return (
    <div className={styles.Container}>
      <div className={styles.CategoryWrapper}>
        <button
          type="button"
          className={byStyleClass}
          onClick={() => setCategoryType(true)}
        >
          By Style
        </button>
        <button
          type="button"
          className={byLocationClass}
          onClick={() => setCategoryType(false)}
        >
          By Location
        </button>
        <div className={styles.BreakLine} />
      </div>
      <div className={styles.ListWrapper}>
        { list.map(({ image, link }: IPrismicCategoryGroup) => (
          <ListItem
            link={link}
            image={image}
          />
        ))}
      </div>
    </div>
  );
};

interface IListItemProps {
  link: IPrismicLink;
  image: IPrismicImage;
}

function ListItem({ link, image }: IListItemProps) {
  const { alt, url } = image;
  const { uid } = link;
  return (
    <a
      key={uid}
      className={styles.ListItem}
      href={`/interior-designers/${uid}`}
    >
      <img src={url} alt={alt || ''} />
      <p>{beautifyCityString(uid)}</p>
    </a>
  );
}

export default ExploreDesigners;
